import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[lang]/_components/consent-modal/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FeatureFlags"] */ "/app/src/components/context/feature-flag.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UserContext"] */ "/app/src/components/context/user.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AdsProvider"] */ "/app/src/components/core/components/molecules/ads/context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/core/components/organism/layout-contexts/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/globals.styles.ts");
;
import(/* webpackMode: "eager", webpackExports: ["LinguiClientProvider"] */ "/app/src/locales/index.tsx");
